import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, Form, Row, Table } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useAppDispatch } from '../../../../app/hooks';
import { setModal } from '../../../../common/slices/commonSlice';
import { perProps } from '../../../../common/types/commonTypes';
import { debounce } from '../../../../common/utils/common.utils';
import usePagination from '../../../../common/utils/usePagination';
import useUrlParams from '../../../../common/utils/useUrlParams';
import BreadCrumb from '../../../../components/common/breadCrumb/BreadCrumb';
import { FormInput } from '../../../../components/common/FormItem/FormItems';
import { loadingIndicator } from '../../../../components/common/spinner/LoadingIndicator';
import { parseDateRangeObject } from '../../../../helpers/healper';
import { useGetAllAgentProfileListQuery } from '../api/endpoints/agentProfileEndPoints';
import { AgentProfileDataType } from '../types/agentProfileTypes';
import { columns } from '../utils/utils';

const AgentsProfile = ({ permission }: perProps) => {
  const navigate = useNavigate();
  const { setUrlParam, getAllUrlParams } = useUrlParams();
  const { page, size, changePagination, pagination } = usePagination();
  const params_value = getAllUrlParams() as {
    search: string | null;
    from_date: string | null;
    to_date: string | null;
  };

  const [editInfo, setEditInfo] = useState<AgentProfileDataType | null>(null);
  const dispatch = useAppDispatch();

  const showAddAgentModal = () => {
    dispatch(setModal(true));
  };

  const {
    data,
    isFetching,
    refetch: getAllRefetch,
    isLoading: dataIsLoading,
  } = useGetAllAgentProfileListQuery({
    ...getAllUrlParams(),
    page,
    size,
  });
  // Add safety check for data mapping
  const dataWithKey =
    data?.data?.map((item, index) => ({
      key: String(index),
      ...item,
    })) || [];

  const [form] = useForm();

  const handelSearch = useCallback(
    debounce((e: string) => {
      setUrlParam('search', e);
    }, 600),
    []
  );

  useEffect(() => {
    form.setFieldsValue({
      search: params_value.search || '',
      date_range: parseDateRangeObject({
        from_date: params_value.from_date,
        to_date: params_value.to_date,
      }),
    });
  }, [params_value]);
  return (
    <div>
      <BreadCrumb arrOfOption={['Agent Profile']} reloaderSize='small' />

      <Row justify={'space-between'} gutter={{ xs: 8, sm: 16, md: 24, lg: 24 }}>
        <Col>
          {permission?.['create:any'] && (
            <Button
              type='primary'
              onClick={(e) => navigate('../agents/add', { state: '/agents/profile' })}
              style={{ marginRight: '15px' }}
            >
              <PlusOutlined />
              Add Agent
            </Button>
          )}
        </Col>

        <Col span={12}>
          <Form form={form}>
            <Row justify={'end'} gutter={[10, 10]}>
              <FormInput
                name={'search'}
                placeholder='Search here ...'
                onChange={(e: string) => handelSearch(e.trim())}
              />
            </Row>
          </Form>
        </Col>
      </Row>

      <Table
        // rowKey={(record) => record.id}
        size='small'
        bordered
        columns={columns(setEditInfo, showAddAgentModal, pagination, permission)}
        dataSource={dataWithKey}
        loading={{
          spinning: dataIsLoading || isFetching,
          indicator: loadingIndicator,
        }}
        scroll={{ x: 'max-content' }}
        pagination={changePagination(data?.count)}
      />
    </div>
  );
};

export default AgentsProfile;
